<script>
import NewForm from "./New";
export default {
  mixins: [NewForm],
  mounted() {
    this.load();
  },
  computed: {
    isEdit() {
      return true;
    },
  },
  methods: {
    load() {
      this.$http.get(`/ports/${this.$route.query.code}`).then((res) => {
        this.form = res.data;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.$http.put(`/ports/${this.$route.query.code}`, this.form).then(() => {
        this.$router.go(-1);
      });
    },
    remove() {
      this.$confirm({
        content: this.$t("app.messages.removeConfirm"),
      }).then(() => {
        this.$http.delete(`/ports/${this.$route.query.code}`).then(() => {
          this.$router.go(-1);
          this.$message("", "削除成功");
        });
      });
    },
  },
};
</script>
